module.exports = __webpack_public_path__ + "img/planetfall.9ad22b70.png";